module.exports = __webpack_public_path__ + "img/grid.f29e1862.svg";